export default __webpack_public_path__ + "static/SALUD-90a7e9498fca27c7f5cc336de8461769.jpg";